function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import BaseTheme from './themes';
import { StyledGlobalFont } from './Theme.style';
import themes from '@nab/nui-themes-web';
import { NuiContext } from './context';
import { validateThemeName } from '../../utils';
var themesTypes = Object.keys(themes);
Theme.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(_toConsumableArray(themesTypes))
};
Theme.defaultProps = {
  children: '-',
  theme: defaultThemeName
};
export var defaultThemeName = 'nab';
export function Theme(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  var currentTheme = BaseTheme(themes[validateThemeName(theme)]);
  return /*#__PURE__*/React.createElement(NuiContext.Provider, {
    value: {
      themeName: theme || 'nab'
    }
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: currentTheme
  }, /*#__PURE__*/React.createElement(StyledGlobalFont, null, children)));
}